var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt-entity-avatar"},[_c('figure',{staticClass:"image",class:!_vm.mapMarker && _vm.sizeClass},[_c('img',{class:_vm.imgClass,style:(_vm.imgStyle),attrs:{"src":_vm.avatar,"alt":"avatar"},on:{"error":_vm.avatarOnError}})])])}
var staticRenderFns = []

export { render, staticRenderFns }